
import "./Services.css";

const servicesData = [
  {
    id: 1,
    title: "Artwork Management",
    image: "/images/art.svg",
    features: [
      { title: "File Preparation :", description: "We ensure your artwork meets the highest standards for printing and production." },
      { title: "Color Management :", description: "We maintain color consistency across all your packaging materials." },
      { title: "Version Control :", description: "We manage multiple versions of your artwork efficiently." },
      { title: "Digital Asset Management :", description: "We provide secure storage and access to your artwork files." },
    ],
  },
  {
    id: 2,
    title: "Label Design & Development",
    image: "/images/label.svg",
    features: [
      { title: "Crafting Compelling Labels :", description: "Our team designs eye-catching labels that communicate your brand story and resonate with your target audience." },
      { title: "Seamless Integration :", description: "We ensure your labels integrate flawlessly with your packaging, creating a cohesive and impactful brand experience." },
    ],
  },
  {
    id: 3,
    title: "Packaging Design & Development",
    image: "/images/triangle.png",
    features: [
      { title: "Structural Design :", description: "We create packaging structures that are functional, protective, and aesthetically pleasing." },
      { title: "Material Selection :", description: "We choose sustainable and cost-effective materials that align with your brand values and product requirements." },
      { title: "Prototyping & Testing :", description: "We create prototypes to refine your packaging design and ensure its performance." },
      { title: "Production & Fulfillment :", description: "We oversee the production process and ensure timely delivery of your packaging." },
    ], 
  },
  {
    id: 4,
    title: "Sustainable Packaging Development",
    image: "/images/sustp.png",
    features: [
      { title: "Environmentally Friendly :", description: "We utilize sustainable materials and processes to minimize your environmental footprint.", icon: "/images/green1.svg" },
      { title: "Recyclable & Compostable :", description: "We prioritize packaging options that can be recycled or composted, promoting a circular economy.", icon: "/images/green2.svg" },
      { title: "Reduced Waste & Footprint :", description: "We optimize packaging designs to minimize material usage and reduce waste generation.", icon: "/images/green3.svg" },
      { title: "Bio-based Materials :", description: "We explore innovative bio-based materials that are both sustainable and performant.", icon: "/images/green4.svg" },
    ], 
  },
  {
    id: 5,
    title: "Cost-Saving Solutions",
    image: "/images/key.svg",
    features: [
      { title: "Material Optimization :", description: "We select cost-effective materials without compromising quality or sustainability." },
      { title: "Design Efficiency :", description: "We streamline the design process to reduce development time and costs." },
      { title: "Production Optimization :", description: "We optimize production processes to minimize waste and increase efficiency." },
      { title: "Strategic Sourcing :", description: "We leverage our network of suppliers to secure competitive pricing and quality materials." },
    ], 
  },
  {
    id: 6,
    title: "Vendor Management",
    image: "/images/venderm.svg",
    features: [
      { title: "Vendor Identification :", description: "Conduct market research to identify potential vendors that align with your organization's needs and values." },
      { title: "Evaluation & Selection :", description: "Thoroughly evaluate vendors based on criteria such as capabilities, experience, financial stability, and cultural fit." },
      { title: "Contract Negotiation :", description: "Negotiate favorable terms, including pricing, service-level agreements, and dispute resolution procedures." }
    ], 
  }

];

function ServiceSections() {
  return (
    <section className="services">
      {servicesData.map((service, index) => (
        <div key={service.id} className="service-block">
          <div className="service-header">{service.title}</div>
          <div className="content-wrapper">
            <img src={service.image || "/images/seperator.svg"} alt={service.title} className="service-image" />
            <div className="feature-list">
              {service.features.map((feature, idx) => (
                <div key={idx} className="feature-item">
                  {feature.icon && <img src={feature.icon} alt="Feature Icon" className="feature-icon" />}
                  <div>
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
              <button className="service-button">Continue to Get a Quote</button>
            </div>
          </div>
          {index < servicesData.length - 1 && <div className="divider"><img src="/images/seperator.svg" alt="Divider" /></div>}
        </div>
      ))}
    </section>
  );
}

export default ServiceSections;

